import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <Link to="/" className="navbar-logo" style={{ marginBottom: '1rem', display: 'inline-flex', background: 'white', padding: '0.5rem 1rem', borderRadius: '10px', alignItems: 'center', gap: '0.6rem' }}>
              <span style={{ fontSize: '1.4rem' }}>🦷</span>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '1.1rem', fontWeight: 800, color: 'var(--color-navy, #0f2040)', lineHeight: 1.1 }}>
                  UK Dental <span style={{ color: '#e12454' }}>Studio</span>
                </span>
                <span style={{ fontSize: '0.65rem', color: '#656565', fontWeight: 600 }}>
                  Dr. Tanya Chauhan & Team
                </span>
              </div>
            </Link>
            <p>
              UK Dental Studio is among the best multispecialty dental clinics in Haridwar. 
              Led by Dr. Tanya Chauhan (BDS General practitioner), our core philosophy is based 
              on the amalgamation of art with modern dental science, delivering high-quality, painless treatment with a warm "Family wali feeling".
            </p>
            <div className="footer-social">
              <a href="https://facebook.com/drtanyachauhan" className="social-link" aria-label="Facebook" id="footer-facebook"><FaFacebook /></a>
              <a href="https://instagram.com/globaldental_clinic" className="social-link" aria-label="Instagram" id="footer-instagram"><FaInstagram /></a>
              <a href="https://youtube.com" className="social-link" aria-label="YouTube" id="footer-youtube"><FaYoutube /></a>
              <a href="https://linkedin.com" className="social-link" aria-label="LinkedIn" id="footer-linkedin"><FaLinkedin /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Dental Treatments</Link></li>
              <li><Link to="/doctors">Our Specialists</Link></li>
              <li><Link to="/appointments">Book Appointment</Link></li>
              <li><Link to="/blog">Oral Health Blog</Link></li>
              <li><Link to="/testimonials">Patient Reviews</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Dental Specialties */}
          <div>
            <h4 className="footer-heading">Dental Specialties</h4>
            <ul className="footer-links">
              <li><Link to="/services#dental-implants">Best Dental Implants</Link></li>
              <li><Link to="/services#single-sitting-rct">Single Sitting RCT</Link></li>
              <li><Link to="/services#braces-and-orthodontics">Painless Braces & Invisalign</Link></li>
              <li><Link to="/services#3d-intraoral-scanner">3Shape 3D Intraoral Scanner</Link></li>
              <li><Link to="/services#digital-opg-xray">Kodak Digital OPG X-Ray</Link></li>
              <li><Link to="/services#cosmetic-dentistry">Teeth Whitening & Veneers</Link></li>
              <li><Link to="/services#cosmetic-dentistry">Sparkling Tooth Jewelry</Link></li>
              <li><Link to="/about">Strict Sterilization Protocol</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="footer-heading">Clinic Locations</h4>
            <div className="footer-contact-item">
              <FaMapMarkerAlt className="footer-contact-icon" />
              <span>
                <strong>UK DENTAL STUDIO</strong><br />
                1ST FLOOR, UK DENTAL STUDIO,<br />
                NAVODAYA CHOWK, above PRIYA MEDICAL STORE<br />
				NAVODAYA NAGAR, Aneki Hetmapur,<br />
                 Haridwar, Uttarakhand 249412<br /><br />
              </span>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="footer-contact-icon" />
              <span>
                <a href="tel:+919536113530" style={{ color: 'inherit' }}>+91 95361 13530</a><br />
                <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>Call / WhatsApp for Appointment</span>
              </span>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope className="footer-contact-icon" />
              <span>
                <a href="mailto:Ukdentalstudio16@gmail.com" style={{ color: 'inherit' }}>Ukdentalstudio16@gmail.com</a>
              </span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">🕐</span>
              <span>
                Mon–Sat: 11:00 AM – 8:00 PM<br />
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>© 2026 UK Dental Studio. All rights reserved. | Dr. Tanya Chauhan & Team</p>
          <div className="footer-bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/disclaimer">Dental Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
